<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="20" >
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                        <el-form-item label="openId">
                            <el-input v-model="formInline.openId" placeholder="openId"></el-input>
                        </el-form-item>
                        <el-form-item label="开始日期">
                            <el-date-picker
                                    v-model="formInline.start"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="不选择默认查询当天">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期">
                            <el-date-picker
                                    v-model="formInline.end"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="mini" @click="getJoinRcordList">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <el-table :data="joinList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="activeName" label="活动名称" width="150" ></el-table-column>
            <el-table-column prop="orderMainNo" label="订单号" width="170" ></el-table-column>
            <el-table-column label="头像"  >
                <template slot-scope="scope">
                    <img :src="scope.row.headImageUrl"  class="head_pic"/>
                </template>
            </el-table-column>
            <el-table-column label="昵称" width="170" >
                <template slot-scope="scope">
                    <a :href="getLink(scope.row.customerId)" alt="点击查看用户详情" target="_blank">{{scope.row.nickName==null?'无':scope.row.nickName==''?'未关注用户':scope.row.nickName}}</a>
                </template>
            </el-table-column>
            <!--<el-table-column prop="orderMainNo" label="订单号" width="170"></el-table-column>-->
            <el-table-column label="邀请人数" >
                <template slot-scope="scope">
                    <span>{{scope.row.inviteCount}}人</span>
                </template>
            </el-table-column>
            <!--<el-table-column label="成团人数" v-show="scope.row.activeType==23">-->
                <!--<template slot-scope="scope">-->
                    <!--<span>{{scope.row.joinNum}}人</span>-->
                <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="团状态" v-show="scope.row.activeType==23">-->
                <!--<template slot-scope="scope">-->
                    <!--<span>{{scope.row.prizeStatusName}}人</span>-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column prop="createTime" label="参与时间"  ></el-table-column>

            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" v-show="scope.row.isPrize>=1" @click="getInviteDetail(scope.row)">邀请明细</el-button>
                    <el-button type="success" v-show="scope.row.isPrize==1&&scope.row.inviteCount>=1" size="mini" @click="prize(scope.row)">协助兑奖</el-button>
                </template>
            </el-table-column>

        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="邀请明细" :visible.sync="showDialog">
            <el-table :data="grouponDetailOrderVoList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <!--<el-table-column prop="activeName" label="活动名称" width="170" ></el-table-column>-->
                <el-table-column prop="headImageUrl" label="头像" >
                    <template slot-scope="scope">
                        <el-avatar size="small" :src="scope.row.headImageUrl"></el-avatar>
                    </template>
                </el-table-column>
                <el-table-column prop="nickName" label="昵称" width="170" >
                    <template slot-scope="scope">
                        <a :href="getLink(scope.row.customerId)" alt="点击查看邀请用户" target="_blank">{{scope.row.nickName==null?'无':scope.row.nickName==''?'未关注用户':scope.row.nickName}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="orderMainNo" label="订单号" width="170">
                    <template slot-scope="scope">
                        <a :href="getOrderLink(scope.row.orderMainNo)" alt="点击查看订单" target="_blank">{{scope.row.orderMainNo}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="活动参与时间" ></el-table-column>
                <el-table-column prop="statusName" label="拼团状态" width="80" sortable>
                    <!--<template slot-scope="scope">-->
                        <!--<el-tag size="mini" v-if="scope.row.status==0" effect="plain">未参与</el-tag>-->
                        <!--<el-tag size="mini" v-if="scope.row.status==1" type="success" effect="plain">已参与</el-tag>-->
                        <!--<el-tag size="mini" v-if="scope.row.status==2" type="success" effect="plain">已兑奖</el-tag>-->
                    <!--</template>-->
                </el-table-column>
                <!--<el-table-column label="邀请来源" fixed="right">-->
                    <!--<template slot-scope="scope">-->
                        <!--<a :href="getLink(scope.row.sourceCustomerId)" alt="点击查看邀请用户" target="_blank">{{scope.row.sourceNickName==null?'无':scope.row.sourceNickName==''?'未关注用户':scope.row.sourceNickName}}</a>-->
                    <!--</template>-->
                <!--</el-table-column>-->

            </el-table>
        </el-dialog>

    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getJoinRcordListApi,getInviteDetailApi,prizeApi
    } from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    openId: "",
                    start:'',
                    end:'',
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                loading: true,
                showDialog:false,
                activeTypeList: [{value: 22, name: '仅允许邀请新用户参加'}, {value: 19, name: '邀请不限制'}],
                joinList:[],
                grouponDetailOrderVoList:[]
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getJoinRcordList();
        },
        methods: {
            prize(row) {
                this.$confirm('操作不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //删除继续
                    this.loading = true;
                    prizeApi({'inviteId':row.inviteId}).then((res) => {
                        this.loading = false;
                        if (res.data.status == 200) {
                            this.$message({
                                message: '兑奖成功',
                                type: 'success'
                            });
                            this.getJoinRcordList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
            getJoinRcordList() {
                this.loading = true;
                if(this.formInline.start!=''){
                    this.formInline.start=this.formInline.start+' 00:00:00';
                }
                if(this.formInline.end!=''){
                    this.formInline.end=this.formInline.end+' 00:00:00';
                }
                getJoinRcordListApi(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.joinList = res.data.value.list;
                        this.formInline.recordsTotal = res.data.value.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getStatusName(activeNo){
                for ( var i = 0; i <this.activeList.length; i++){
                    if(this.activeList[i].activeNo==activeNo){
                        return this.activeList[i].activeName;
                    }
                }
                return '';
            },
            getLink(customerId){
                let returnUrl = ''
                returnUrl = `${window.location.origin}/#/usersystem/detail/${customerId}`
                return returnUrl
            },
            getOrderLink(orderMainNo){
                let returnUrl = ''
                returnUrl = `${window.location.origin}/#/queryorder?orderMainNo=${orderMainNo}`
                return returnUrl
            },
            getInviteDetail(row){
                console.log('查看用户邀请记录:'+row)
                //查看邀请明细
                this.loading = true;
                this.showDialog=true;
                getInviteDetailApi({"inviteId":row.inviteId}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.inviteList = res.data.value;
                        for( let i of this.inviteList){
                            i.sourceNickName=row.nickName;
                            i.orderMainNoUrl='//erpnew.lechun.cc/admin_sold_show.html?SOLD_ID='+i.orderMainNo;
                        }
                        console.log(this.inviteList);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            handleEdit(collageConfig){
//                this.listCollageShow = false;
            },
            getUserDetailUrl(customerId){
                return '//erpnew.lechun.cc/mall_customer_edit.html?customerid='+customerId;
                this.$router.push({path:'/userSystem/detail/:id',name: 'userSystemContent',params:{id:customerId}})
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getJoinRcordList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getJoinRcordList();
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .head_pic{
        border-radius: 30px;
        width:132px;
        height:132px;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/fit/joinList.vue